//@ts-nocheck
import { SAMOLET_YM_COUNTER } from '../constants/common';
import { checkIsYMCounterInitiated } from '../helpers/common';
import { useEffect, useRef } from 'react';
export var useYaMetricaUserParams = function (profile, ymetrika) {
    var isUserParamsSent = useRef(false);
    var isYMInitDone = useRef(false);
    var roleKey = (ymetrika === null || ymetrika === void 0 ? void 0 : ymetrika.roleKey) || 'role';
    useEffect(function () {
        var isYaMetrikaExists = function () {
            try {
                return !!ym;
            }
            catch (e) {
                return false;
            }
        };
        try {
            var isStageOrDev = ['-stage', 'localhost', '127.0.0.1'].some(function (e) {
                return window.location.host.includes(e);
            });
            if (isStageOrDev)
                return;
            if (!isYaMetrikaExists()) {
                (function (m, e, t, r, i, k, a) {
                    m[i] =
                        m[i] ||
                            function () {
                                // eslint-disable-next-line prefer-rest-params
                                (m[i].a = m[i].a || []).push(arguments);
                            };
                    m[i].l = 1 * new Date();
                    (k = e.createElement(t)),
                        (a = e.getElementsByTagName(t)[0]),
                        (k.async = 1),
                        (k.src = r),
                        a.parentNode.insertBefore(k, a);
                })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');
            }
            if (!isYMInitDone.current && !checkIsYMCounterInitiated()) {
                ym(SAMOLET_YM_COUNTER, 'init', {
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                });
                isYMInitDone.current = true;
            }
            if (isUserParamsSent.current || !profile)
                return;
            if (profile.id && (!profile.guid || !profile[roleKey])) {
                console.warn("\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0443 django-samolet \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F guid \u0438 " + roleKey);
                return;
            }
            ym(SAMOLET_YM_COUNTER, 'userParams', {
                UserID: profile.guid,
                role: profile[roleKey],
            });
            isUserParamsSent.current = true;
        }
        catch (e) {
            console.error("useYaMetricaUserParams - " + e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);
};
//# sourceMappingURL=useSamoletYaMetrica.js.map